<div *ngIf="showComponent && !forceHideButtion" class="opt-in__container">
    <button [ngStyle]="{'display': disableGamePlay ? 'none' : 'block' }"  class="btn btn-xl btn-primary" #optInBtn role="button" (click)="openOptInPop()"
        [attr.aria-label]="buttonText">{{buttonText}}</button>
</div>
<ng-template #optInModal>
    <form #optInForm="ngForm">
        <div class="episodic-header">
            <button id="optInClose" type="button" class="close" data-dismiss="modal" aria-label="Almost there we need to capture little more information dialog close button" data-tabindex="first" (click)="closeModal(optInForm);">
                <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
            </button>
        </div>
        <div class="episodic-body">
            <div class="title-lg-bold episodic-body__title" role="heading" aria-level="2" aria-label="Almost there we need to capture little more information to opt in the game">
                Almost there
            </div>
            <div class="body-text-sm episodic-body__text ml-5 mr-5 mb-3">
                We need to capture a little extra information.
            </div>
            <div class="body-text-sm episodic-body__addressform ml-1 mr-1 mb-3">
                <div class="two-column">
                    <div class="input-field" >
                        <div [ngClass]="firstName.invalid && firstName.touched && firstName.errors ? 'input-field--error' : 'input-field__wrapper'">
                            <label class="input-field__float-label">
                                <input type="text" placeholder=" " id="optIn-input-firstname" class="floating__input"  #firstName="ngModel" [(ngModel)]="user.firstName"  
                                aria-label="Please enter your first name which is required field. It should be between 2 and 30 characters and includes only letters or hyphens" [ngClass]="firstName.invalid && firstName.dirty && firstName.touched && firstName.errors ? 'flt-error-input' : 'flt-noerror'" 
                                name="firstName" placeholder="First name" required
                                [disabled]="profileData.firstName.length" minlength="2" maxlength="30" pattern="^[a-zA-Z][\'\. a-zA-Z-]*$" autocomplete="off" aria-describedby="eps-err-fname"/>
                                <span>First name <span class="episodic-body__primaryText">*</span></span>
                            </label>
                        </div>
                        <div class="input-field__help-text body-text-xs">
                            <div *ngIf="firstName.invalid && firstName.touched && firstName.errors" class="input-field__help-text--error" id="eps-err-fname" aria-live="assertive">
                                <ul class="list-unstyled">
                                    <li *ngIf="firstName.errors.required">Please enter your first name.</li>
                                    <li *ngIf="firstName.errors.minlength">Please enter a first name that is between 2 - 30 characters</li>
                                    <li *ngIf="firstName.errors.pattern">Names are limited to letters, apostrophes, periods and hyphens</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="input-field">
                        <div [ngClass]="lastName.invalid && lastName.touched && lastName.errors ? 'input-field--error' : 'input-field__wrapper'">
                            <label class="input-field__float-label">
                                <input type="text" id="optIn-input-lastname" class="floating__input" [(ngModel)]="user.lastName"  #lastName="ngModel"   aria-label="Please enter your last name which is required field. It should be between 2 and 30 characters and includes only letters or hyphens" [ngClass]="lastName.invalid && lastName.dirty && lastName.touched && lastName.errors ? 'flt-error-input' : 'flt-noerror'" 
                                name="lastName" placeholder="Last name" required
                                [disabled]="profileData.lastName.length" minlength="2" maxlength="30" pattern="^[a-zA-Z][\'\. a-zA-Z-]*$" autocomplete="off" aria-describedby="eps-err-lname"/>
                                <span>Last name <span class="episodic-body__primaryText">*</span></span>
                            </label>
                        </div>
                        <div class="input-field__help-text body-text-xs">
                            <div *ngIf="lastName.invalid && lastName.touched && lastName.errors" class="input-field__help-text--error" id="optIn-err-lname" aria-live="assertive">
                                <ul class="list-unstyled">
                                    <li *ngIf="lastName.errors.required">Please enter your last name.</li>
                                    <li *ngIf="lastName.errors.minlength">Please enter a last name that is between 2 - 30 characters</li>
                                    <li *ngIf="lastName.errors.pattern">Names are limited to letters, apostrophes, periods and hyphens</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input-field">
                    <div [ngClass]="email.invalid && email.dirty && email.touched && email.errors ? 'input-field--error' : 'input-field__wrapper'">
                        <div class="input-field__wrapper">
                            <label class="input-field__float-label">
                                <input id="optIn-input-email" type="email" class="floating__input" [(ngModel)]="user.email"  #email="ngModel"  aria-label="Please enter your email Id which is required field and valid email address"  [ngClass]="email.invalid && email.dirty && email.touched && email.errors ? 'flt-error-input' : 'flt-noerror'" name="email" placeholder="Email" required [disabled]="profileData.email.length > 0"
                                maxlength="50" pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.([a-zA-Z0-9-.]+)$" autocomplete="off" aria-describedby="optIn-err-email" />
                                <span>Email <span class="episodic-body__primaryText">*</span></span>
                            </label>
                        </div>
                    </div>
                    <div class="input-field__help-text body-text-xs">
                        <div *ngIf="email.invalid && email.dirty && email.touched && email.errors" class="input-field__help-text--error" id="optIn-err-email" aria-live="assertive">
                            <ul class="list-unstyled">
                                <li *ngIf="email.errors.required">Please enter your email address</li>
                                <li *ngIf="email.errors.pattern">Please enter a valid email address</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="input-field">
                    <div [ngClass]="phoneNumber.invalid && phoneNumber.dirty && phoneNumber.touched && phoneNumber.errors ? 'input-field--error' : 'input-field__wrapper'">
                    <div class="input-field__wrapper">
                        <label class="input-field__float-label" for="optIn-input-phoneNumber">
                            <input minlength="10" id="optIn-input-phoneNumber" maxlength="10" pattern="^[0-9]*$" type="tel" placeholder=" " class="floating__input" [(ngModel)]="user.phoneNumber" autocomplete="off" #phoneNumber="ngModel" name="phoneNumber" [disabled]="(phoneNum && profileData.phones && profileData.phones[0].number.length > 0)" required />
                            <span>Phone Number <span class="episodic-body__primaryText">*</span></span>
                        </label>
                    </div>
                    </div>
                    <div class="input-field__help-text body-text-xs">
                        <div *ngIf="phoneNumber.invalid && phoneNumber.dirty && phoneNumber.touched && phoneNumber.errors" class="input-field__help-text--error" id="optIn-err-phoneNumber" aria-live="assertive">
                            <ul class="list-unstyled">
                                <li *ngIf="phoneNumber.errors.required">Please enter your phone number</li>
                                <li *ngIf="phoneNumber.errors.pattern">Please enter numberic numbers</li>
                                <li *ngIf="phoneNumber.errors.minlength">Please enter valid phone number</li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="mb-2">Birthdate <span class="episodic-body__primaryText">*</span></div>
                <div class="two-column">
                    <div class="input-field">
                        <div class="text-dropdown" [ngClass]="(month.dirty || month.touched) && user.month == 'Month' ? 'input-field--error' : 'input-field__wrapper'">
                            <label for="month" class="input-field__float-label">
                                <select id="month" name="month" required [(ngModel)]="user.month" #month="ngModel" (change)="monthsHandler($event.target.value)">
                                    <option>Month</option>
                                    <option
                                      *ngFor="let month of months; let i = index"
                                      [value]="month"
                                      [selected]="i == -1"
                                    >
                                      {{ month }}
                                    </option>
                                  </select>
                                <span>Month</span> 
                            </label>
                        </div>
                        <div class="input-field__help-text body-text-xs">
                            <div *ngIf="(month.dirty || month.touched) && user.month == 'Month'" class="input-field__help-text--error" id="optIn-err-month" aria-live="assertive">
                                <ul class="list-unstyled">
                                    <li>Please select month</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="input-field">
                        <div class="text-dropdown" [ngClass]="(day.dirty || day.touched) && user.day == 'Day' ? 'input-field--error' : 'input-field__wrapper'">
                            <label for="day" class="input-field__float-label">
                                <select id="day" [(ngModel)]="user.day" #day="ngModel" name="day" required (change)="daysHandler($event.target.value)">
                                    <option>Day</option>
                                    <option
                                      *ngFor="let day of days"
                                      value="{{ day }}"
                                      [selected]="i == -1"
                                    >
                                      {{ day }}
                                    </option>
                                  </select>
                                <span>Day</span>
                            </label>
                        </div>
                        <div class="input-field__help-text body-text-xs">
                            <div *ngIf="(day.dirty || day.touched) && user.day == 'Day'" class="input-field__help-text--error" id="optIn-err-month" aria-live="assertive">
                                <ul class="list-unstyled">
                                    <li>Please select day</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="input-field">
                        <div class="text-dropdown" [ngClass]="(year.dirty || year.touched) && user.year == 'Year' ? 'input-field--error' : 'input-field__wrapper'">
                            <label for="year" class="input-field__float-label">
                                <select id="year" name="year" [(ngModel)]="user.year" #year="ngModel" required (change)="yearHandler($event.target.value)">
                                    <option>Year</option>
                                    <option
                                      *ngFor="let year of years"
                                      value="{{ year }}"
                                      [selected]="i == -1"
                                    >
                                      {{ year }}
                                    </option>
                                  </select>
                                <span>Year</span>
                            </label>
                        </div>
                        <div class="input-field__help-text body-text-xs">
                            <div *ngIf="(year.dirty || year.touched) && user.year == 'Year'" class="input-field__help-text--error" id="optIn-err-month" aria-live="assertive">
                                <ul class="list-unstyled">
                                    <li>Please select year</li>
                                </ul>
                            </div>
                        </div>
                        </div>
                </div>
                <div class="two-column termsconditions mt-2 mb-2">
                    <div class="checkbox ml-1">
                        <label class="checkbox__group" for="optInChk" aria-label="Checkbox">
                            <input class="checkbox__input checkbox__input" type="checkbox" aria-checked="false" id="optInChk" tabindex="0" [(ngModel)]="user.tncCheckbox"  #tncCheckbox="ngModel" aria-label="please check the checkbox to agree terms and conditions" name="tncCheckbox" role="checkbox" aria-checked="false" required>
                            <span class="checkbox__checkmark"><span class="svg-checkmark"></span></span>
                        </label>
                    </div>
                    <div class="body-text-sm episodic-body__text mr-5 episodic-body__alignleft">I agree to the
                        <a href="{{programRulesLink}}" target="_blank" class="episodic-body__primaryText underline">Official Rules</a></div>
                </div>
                <div class="input-field mt-4 mb-3">
                    <button [ngStyle]="{'display': disableGamePlay ? 'none' : 'block' }"  (click)="optInGameHandler()" class="btn btn-xl btn-primary episodic-footer__button" [disabled]="firstName.errors || lastName.errors || email.errors || phoneNumber.errors || !user.tncCheckbox || user.month == 'Month' || user.day == 'Day' || user.year == 'Year'" >
                        <ng-container *ngIf="disableStartPlaying == false else loadspinner">
                            Start playing
                        </ng-container>
                    </button>
                    <div class="body-text-sm episodic-body__text mr-5 episodic-body mt-3"> 
                        <a href="https://www.albertsonscompanies.com/policies-and-disclosures/privacy-policy/default.aspx" target="_blank" data-tabindex="last" class="episodic-body__primaryText underline">Privacy Policy</a> 
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #loadspinner>
    <div alt="Loading..." class="small progress">
        <div class="prog1">
            <div class="prog2"></div>
        </div>
    </div>
</ng-template>

<!-- Can't play Modal Begins -->
<ng-template #cantPlayPopup>
    <div class="episodic-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-tabindex="first" (click)="cantPlayPopupRef.hide();analyticsModalTracking('we-are-sorry|closed','click')">
            <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
        </button>
    </div>
    <div class="episodic-warning">
        <span class="svg-warning-outline"></span>
    </div>
    <div class="episodic-body pl-4 pr-4">
        <div class="title-lg-bold episodic-body__title">
            We're sorry
        </div>
        <div class="episodic-body__text">
            {{errorMessageText}}
        </div>
    </div>
    <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
        <button class="btn btn-xl btn-primary body-text episodic-footer__button" aria-label="Retry" data-tabindex="last" (click)="cantPlayPopupRef.hide();analyticsModalTracking('we-are-sorry|closed','click')">Got it</button>
    </div>
</ng-template>
<!-- Error Modal Ends -->

<!-- Error Modal Begins -->
<ng-template #errorPopup>
    <div class="episodic-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-tabindex="first" (click)="errorPopupRef.hide()">
            <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
        </button>
    </div>
    <div class="episodic-warning">
        <span class="svg-warning-outline"></span>
    </div>
    <div class="episodic-body pl-4 pr-4">
        <div class="title-lg-bold episodic-body__title">
            There was an issue
        </div>
        <div class="episodic-body__text">
            There was a technical issue. Please retry
        </div>
    </div>
    <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
        <button class="btn btn-xl btn-primary body-text episodic-footer__button" aria-label="Retry" data-tabindex="last" (click)="errorPopupRef.hide(); optInGameHandler()">Retry</button>
    </div>
</ng-template>
<!-- Error Modal Ends -->